// extracted by mini-css-extract-plugin
module.exports = {"single-canvas_root":"SingleCanvas_single-canvas_root__3IAUX","single-canvas_view-root":"SingleCanvas_single-canvas_view-root__2ZKt8"};